export default "__VITE_ASSET__bxeuLcqF__"